import type { ReactNode } from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";

import actions from "@/actions";

import Button from "../base/Button";

const renderIcon = (color: string): ReactNode => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="25"
        viewBox="0 0 27 25"
    >
        <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="square">
            <path d="M1.25 5V1h4M19.25 1h4v4M10.25 1h4M1.25 17v4h4M19.25 21h4v-4M10.25 21h4M1.25 10v2M23.25 10v2" />
        </g>
        <circle
            cx="20"
            cy="18.5"
            r="5.4"
            fill="#1a1a2e"
            stroke={color}
            strokeWidth="1.2"
        />
        <line
            x1="16.4"
            y1="18.5"
            x2="23.6"
            y2="18.5"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);

const SubtractButton = (props: React.ComponentProps<typeof Button>) => (
    <Button {...props} renderIcon={renderIcon} />
);

const tool = { name: "subtract" };

const mapStateToProps = ({ map }: { map: any }) => ({
    disabled: map.general.selectedLights.length <= 0,
    selected: map.general.selectedTool?.name === "subtract",
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    select: () => dispatch(actions.map.general.selectTool(tool)),
    deselect: () => dispatch(actions.map.general.selectTool(null)),
});

const mergeProps = (
    stateProps: ReturnType<typeof mapStateToProps>,
    dispatchProps: ReturnType<typeof mapDispatchToProps>,
    ownProps: any,
) => ({
    ...ownProps,
    ...stateProps,
    onClick: stateProps.selected
        ? dispatchProps.deselect
        : dispatchProps.select,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
)(SubtractButton);
